import { render, staticRenderFns } from "./SummariesIndex.vue?vue&type=template&id=3df25022&scoped=true&"
import script from "./SummariesIndex.vue?vue&type=script&lang=js&"
export * from "./SummariesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df25022",
  null
  
)

export default component.exports